"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.scss");
var Image_1 = require("../../common/Image");
var style_1 = require("../../../utils/style");
var WithPrm_1 = require("components/WithPrm");
var prm_1 = require("utils/prm");
var _animationDuration = 1000;
var _bannerWidth = 435;
var _countDown = 4000;
var CardBanner = (function (_super) {
    __extends(CardBanner, _super);
    function CardBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            cIndex: 2,
            animationDuration: 0
        };
        _this.autoSwipe = true;
        _this.canClick = true;
        _this.countDown = 0;
        _this.getStyle = function () {
            var _a = _this.state, cIndex = _a.cIndex, animationDuration = _a.animationDuration;
            var style = {};
            var wrapperOffsetLeft = -_bannerWidth * cIndex;
            style.width = _this.getNodeCount + "00%";
            style.transform = "translate3d(" + wrapperOffsetLeft + "px,0,0)";
            style.transitionDuration = animationDuration + "ms";
            style.WebkitTransform = style.transform;
            style.transitionTimingFunction = "ease-out";
            return style;
        };
        _this.onClick = function (e, link) {
            e.preventDefault();
            if (link) {
                open(link, "_blank");
            }
        };
        _this.onNext = function () {
            if (!_this.canClick) {
                return;
            }
            _this.canClick = false;
            _this.setState(function (state) { return ({
                cIndex: state.cIndex + 1,
                animationDuration: _animationDuration
            }); });
        };
        _this.onBack = function () {
            if (!_this.canClick) {
                return;
            }
            _this.canClick = false;
            _this.setState(function (state) { return ({
                cIndex: state.cIndex - 1,
                animationDuration: _animationDuration
            }); });
        };
        _this.onTransitionEnd = function () {
            if (_this.state.cIndex > _this.props.cardBanners.length) {
                _this.setState({
                    cIndex: 1,
                    animationDuration: 0
                });
            }
            if (!_this.state.cIndex) {
                _this.setState({
                    cIndex: _this.props.cardBanners.length,
                    animationDuration: 0
                });
            }
            _this.canClick = true;
        };
        _this.renderCardBanner = function (img, link, index) {
            var w = +_this.props.cardBanners[index].items[0].width || 0;
            var h = +_this.props.cardBanners[index].items[0].height || 0;
            var height = style_1.getBannerImageContainerHeight(420, w, h);
            var prmLink = prm_1.genPrmLink(link, __assign({ position: index + 1 }, _this.props.tprm));
            return (React.createElement("li", { key: index, style: { height: height } },
                React.createElement("a", { "data-href": link, href: prmLink, onClick: function (e) { return _this.onClick(e, link); } },
                    React.createElement(Image_1.default, { key: img, src: img, params: "imageView2/2/w/420", aliSize: 4.2, isLazyLoad: _this.props.positionIndex >= 4 }))));
        };
        return _this;
    }
    CardBanner.prototype.componentDidMount = function () {
        this.autoScroll();
    };
    CardBanner.prototype.componentWillUnmount = function () {
        this.stopAutoScroll();
    };
    CardBanner.prototype.autoScroll = function () {
        var _this = this;
        clearTimeout(this.countDown);
        this.countDown = setTimeout(function () {
            if (_this.autoSwipe && document.visibilityState === "visible") {
                _this.onNext();
            }
            _this.autoScroll();
        }, _countDown);
    };
    CardBanner.prototype.stopAutoScroll = function () {
        clearTimeout(this.countDown);
    };
    CardBanner.prototype.getNodeCount = function () {
        var cardBanners = this.props.cardBanners;
        return cardBanners.length + 4;
    };
    CardBanner.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.cardBanners, cardBanners = _b === void 0 ? [] : _b, id = _a.id;
        return (React.createElement("div", { id: id, className: styles.cardBannerContainer, onMouseEnter: function () { return (_this.autoSwipe = false); }, onMouseLeave: function () { return (_this.autoSwipe = true); } },
            React.createElement("div", { className: styles.leftArrow, onClick: this.onBack }),
            React.createElement("ul", { className: styles.scrollContainer, style: this.getStyle(), onTransitionEnd: this.onTransitionEnd },
                cardBanners
                    .slice(-2)
                    .map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index);
                }),
                cardBanners.map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index);
                }),
                cardBanners
                    .slice(0, 2)
                    .map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index);
                })),
            React.createElement("div", { className: styles.rightArrow, onClick: this.onNext })));
    };
    return CardBanner;
}(React.Component));
exports.default = WithPrm_1.default(CardBanner);
